import React, { useEffect, useState } from 'react';
import { fromEvent } from 'rxjs';
// @ts-ignore
import { map, tap } from 'rxjs';
import { Accordion } from 'coreComponents/design-system/accordion';
import { ContentHelper, createMarkup, htmlDecode } from '../../../helpers';
import { trialList } from 'components/UserTrialList';
const _window = window;
export function PDPInformation() {
    const productInformation = _window.informationData;
    const htmlFaq = document.getElementById('hdnProductFaq');
    const faqTitles = $(htmlFaq).find('.pdp-faq-button > span').toArray();
    const nutrition = document.getElementById('hdnNutritionInfo');
    const faqContent = htmlFaq.getElementsByClassName('pdp-faq-body');
    const description = document.getElementById('hdnProductDescription');
    const ingredients = productInformation.ingredients;
    const howToUse = productInformation.how_to_use;
    const benefits = productInformation.benefits;
    const titleArray = Array.prototype.slice.call(faqTitles);
    const faqArray = Array.prototype.slice.call(faqContent);
    const [nutritionContent, updateNutritionContent] = useState(nutrition ? (nutrition.innerText == '' ? '' : nutrition.innerHTML) : '');
    const [descriptionContent, updateDescriptionContent] = useState(description
        ? description.innerText == ''
            ? ''
            : description.innerHTML
        : '');
    const [ingredientsContent, updateIngredientsContent] = useState(ingredients ? ingredients : '');
    const [benefitsContent, updateBenefitsContent] = useState(benefits ? (benefits[0] === '&' ? htmlDecode(benefits) : benefits) : '');
    const [howToUseContent, updateHowToUseContent] = useState(howToUse ? howToUse : '');
    const updateNutrition = (variantId) => {
        const nutritionContent = ContentHelper.getNutritionContent(variantId);
        if (!nutritionContent)
            return;
        updateNutritionContent(nutritionContent
            ? `<div class="nutrition-info">
            ${nutritionContent}
            <p class="font-sm">The % Daily value (DV) tells you how much a nutrient in a serving of food 
            contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.</p>
          </div>`
            : '');
    };
    const updateProductInfo = (variantId) => {
        const descriptionContent = ContentHelper.getDescriptionContent(variantId);
        if (!descriptionContent)
            return;
        updateDescriptionContent(descriptionContent);
    };
    const updateIngredientsInfo = (variantId) => {
        const ingredientsContent = ContentHelper.getIngredientsContent(variantId);
        if (!ingredientsContent)
            return;
        updateIngredientsContent(ingredientsContent);
    };
    const updateHowToUse = (variantId) => {
        const howToUseContent = ContentHelper.getHowToUseContent(variantId);
        if (!howToUseContent)
            return;
        updateHowToUseContent(howToUseContent);
    };
    const updateBenefits = (variantId) => {
        const benefitsContent = ContentHelper.getBenefitsContent(variantId);
        if (!benefitsContent)
            return;
        updateBenefitsContent(benefitsContent);
    };
    useEffect(() => {
        const packagingOptionsClick = fromEvent($('.packaging-option'), 'click');
        let sub = packagingOptionsClick
            .pipe(map((p) => Object.assign({}, p.currentTarget.dataset)), tap((p) => console.debug(p.variantId)))
            .subscribe((data) => {
            if (data.variantId) {
                updateNutrition(data.variantId);
                updateProductInfo(data.variantId); //description
                updateIngredientsInfo(data.variantId);
                updateHowToUse(data.variantId);
                updateBenefits(data.variantId);
            }
        });
        return function cleanup() {
            sub.unsubscribe();
        };
    }, []);
    const faqs = titleArray
        .map((title, index) => {
        if (faqArray[index]) {
            return {
                name: `faq-${index}`,
                title: title.innerText,
                content: (React.createElement("div", { dangerouslySetInnerHTML: createMarkup(faqArray[index].innerHTML) })),
            };
        }
    })
        .filter(v => v != undefined);
    const faqAccordion = React.createElement(Accordion, { content: faqs });
    let accordionData = [
        {
            name: 'product-information',
            title: 'Product Information',
            content: (React.createElement("div", { dangerouslySetInnerHTML: createMarkup(descriptionContent) })),
        },
    ];
    if (benefitsContent) {
        accordionData.push({
            name: 'benefits',
            title: 'Benefits',
            content: (React.createElement("div", { dangerouslySetInnerHTML: createMarkup(benefitsContent) })),
        });
    }
    if (productInformation && productInformation.user_trails) {
        accordionData.push({
            name: 'user-trails',
            title: 'User Trials',
            content: React.createElement("div", null, trialList(productInformation.user_trials)),
        });
    }
    if (ingredientsContent) {
        accordionData.push({
            name: 'ingredients',
            title: 'Ingredients',
            content: (React.createElement("div", { dangerouslySetInnerHTML: createMarkup(htmlDecode(ingredientsContent)) })),
        });
    }
    if (productInformation && productInformation.amino_acids) {
        accordionData.push({
            name: 'amino-acids',
            title: 'Amino Acids',
            content: (React.createElement("div", { dangerouslySetInnerHTML: createMarkup(htmlDecode(productInformation.amino_acids)) })),
        });
    }
    if (howToUseContent) {
        accordionData.push({
            name: 'how-to-use',
            title: 'How to Use',
            content: (React.createElement("div", { dangerouslySetInnerHTML: createMarkup(htmlDecode(productInformation.how_to_use)) })),
        });
    }
    accordionData.push({
        name: 'vital-faq',
        title: 'Faqs',
        content: faqAccordion,
    });
    return (React.createElement("div", null,
        React.createElement(Accordion, { content: accordionData, drawOpen: true })));
}
